/* import __COLOCATED_TEMPLATE__ from './conversation-tags-table.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();